// extracted by mini-css-extract-plugin
export default {"formGroup":"formGroup__q4X8n","formField":"formField__b5kJz","scoreInput":"scoreInput__tZNMk","error":"error__ObuZz"};